import { _ as __decorate, a as __metadata, B as BaseComponent } from '../index-C155IGn1.js';
import { css, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import 'lit/directive.js';

var styles = css`.thumb-nav {
  --bsi-thumb-nav-gap: var(--bsi-spacing-xxs);
  --bsi-thumb-nav-auto-basis-offset: var(--bsi-spacing-s);
  --bsi-thumb-nav-overlay-offset: var(--bsi-spacing-s);
  --bsi-thumb-nav-item-width: 240px;
  --bsi-thumb-nav-item-width-small: 120px;
  --bsi-thumb-nav-item-height-small-vertical: 80px;
  --bsi-thumb-nav-overlay-bg-primary: var(--bsi-overlay-background-primary);
  --bsi-thumb-nav-overlay-bg-black: var(--bsi-overlay-background-light);
  --bsi-thumb-nav-hover-scale: 1.05;
  --bsi-thumb-nav-transition-duration: 0.4s;
  --bsi-thumb-nav-transition-duration-hover: 1s;
  --bsi-thumb-nav-transition-easing: cubic-bezier(0.15, 0.7, 0.36, 0.99);
  display: flex;
  justify-content: center;
  margin: 0 calc(var(--bsi-thumb-nav-gap) * -1);
  padding: 0;
}
.thumb-nav.thumb-nav-vertical {
  flex-direction: column;
  align-items: baseline;
}
.thumb-nav.thumb-nav-vertical .thumb-nav-resizer {
  width: auto;
  height: 100%;
}
.thumb-nav.thumb-nav-vertical.thumb-nav-small li {
  height: var(--bsi-thumb-nav-item-height-small-vertical);
}
.thumb-nav.thumb-nav-fixed {
  flex-wrap: wrap;
  justify-content: flex-start;
}
.thumb-nav.thumb-nav-fixed li {
  flex-basis: var(--bsi-thumb-nav-item-width);
}
.thumb-nav.thumb-nav-fixed.thumb-nav-small li {
  flex-basis: var(--bsi-thumb-nav-item-width-small);
}
.thumb-nav.thumb-nav-auto {
  flex-wrap: wrap;
  justify-content: flex-start;
}
.thumb-nav.thumb-nav-auto li .thumb-nav-resizer {
  max-width: 100%;
  max-height: 100%;
}
.thumb-nav.thumb-nav-auto.thumb-nav-auto-2 li {
  flex-basis: calc(50% - var(--bsi-thumb-nav-auto-basis-offset));
}
.thumb-nav.thumb-nav-auto.thumb-nav-auto-3 li {
  flex-basis: calc(33.3333% - var(--bsi-thumb-nav-auto-basis-offset));
}
.thumb-nav.thumb-nav-auto.thumb-nav-auto-4 li {
  flex-basis: calc(25% - var(--bsi-thumb-nav-auto-basis-offset));
}
.thumb-nav.thumb-nav-auto.thumb-nav-auto-5 li {
  flex-basis: calc(20% - var(--bsi-thumb-nav-auto-basis-offset));
}
.thumb-nav.thumb-nav-nozoom a:hover img {
  transform: none;
}
.thumb-nav.thumb-nav-black a:hover:after, .thumb-nav.thumb-nav-primary a:hover:after {
  opacity: 1;
}
.thumb-nav.thumb-nav-black a:after {
  background: var(--bsi-thumb-nav-overlay-bg-black);
}
.thumb-nav.thumb-nav-primary a:after {
  background: var(--bsi-thumb-nav-overlay-bg-primary);
}
.thumb-nav.thumb-nav-bottom, .thumb-nav.thumb-nav-top {
  position: absolute;
  left: 50%;
  width: 90%;
  transform: translateX(-50%);
}
.thumb-nav.thumb-nav-bottom {
  bottom: 0;
  margin-bottom: var(--bsi-thumb-nav-overlay-offset);
}
.thumb-nav.thumb-nav-top {
  top: 0;
  margin-top: var(--bsi-thumb-nav-overlay-offset);
}
.thumb-nav.thumb-nav-left, .thumb-nav.thumb-nav-right {
  position: absolute;
  top: 50%;
  height: 90%;
  transform: translateY(-50%);
}
.thumb-nav.thumb-nav-left {
  left: 0;
  margin-left: var(--bsi-thumb-nav-overlay-offset);
}
.thumb-nav.thumb-nav-right {
  right: 0;
  margin-right: var(--bsi-thumb-nav-overlay-offset);
}
.thumb-nav li {
  position: relative;
  flex: 0 1 auto;
  width: var(--bsi-thumb-nav-item-width);
  margin: var(--bsi-thumb-nav-gap);
  list-style-type: none;
}
.thumb-nav .thumb-nav-resizer {
  visibility: hidden;
  width: 100%;
  height: auto;
}
.thumb-nav.thumb-nav-small li {
  width: var(--bsi-thumb-nav-item-width-small);
}
.thumb-nav a {
  position: relative;
  display: block;
  overflow: hidden;
}
.thumb-nav a:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  content: "";
  opacity: 0;
  transition: opacity var(--bsi-thumb-nav-transition-duration) var(--bsi-thumb-nav-transition-easing);
}
.thumb-nav a.active {
  pointer-events: none;
}
.thumb-nav a.active:after {
  opacity: 1;
  background: var(--bsi-thumb-nav-overlay-bg);
}
.thumb-nav a:hover img {
  transform: scale(var(--bsi-thumb-nav-hover-scale));
  transition-duration: var(--bsi-thumb-nav-transition-duration-hover);
}
.thumb-nav a:hover:after {
  transition-duration: var(--bsi-thumb-nav-transition-duration-hover);
}
.thumb-nav a img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: transform var(--bsi-thumb-nav-transition-duration) var(--bsi-thumb-nav-transition-easing);
  object-fit: cover;
}

:host {
  display: block;
}

li {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
}

@supports (font: -apple-system-body) and (-webkit-appearance: none) {
  li::marker {
    font-size: 0;
  }
}
::slotted(a) {
  position: relative;
  display: block;
  overflow: hidden;
}

::slotted(a)::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: var(--it-thumbnav-overlay-bg, transparent);
  content: "";
  opacity: 0;
  transition: opacity 0.4s cubic-bezier(0.15, 0.7, 0.36, 0.99);
}

::slotted(a:hover)::after {
  opacity: var(--it-thumbnav-overlay-hover-opacity, 0);
  transition-duration: 1s;
}

:host([active]) ::slotted(a),
::slotted(a.active) {
  pointer-events: none;
}

:host([active]) ::slotted(a)::after,
::slotted(a.active)::after {
  background: var(--bsi-color-background-primary);
  opacity: 0.6;
}`;

/**
 * Singolo elemento della Thumbnav.
 * Inserisce il contenuto (tipicamente un anchor con immagine) in un elemento `<li>`.
 * Usa l'attributo `active` per indicare l'elemento corrente:
 * `<it-thumbnav-item active><a href="#" class="ratio ratio-3x2"><img …></a></it-thumbnav-item>`
 */
let ItThumbnavItem = class ItThumbnavItem extends BaseComponent {
    constructor() {
        super(...arguments);
        /** Indica l'elemento attivo/corrente nella navigazione. */
        this.active = false;
    }
    render() {
        return html `<li role="presentation"><slot></slot></li>`;
    }
};
ItThumbnavItem.styles = styles;
__decorate([
    property({ type: Boolean, reflect: true }),
    __metadata("design:type", Object)
], ItThumbnavItem.prototype, "active", void 0);
ItThumbnavItem = __decorate([
    customElement('it-thumbnav-item')
], ItThumbnavItem);

export { ItThumbnavItem };
//# sourceMappingURL=it-thumbnav-item.js.map
